<template>
  <div class="tag-display" v-if="normalizedTags.length">
    <span v-for="(tag, idx) in normalizedTags" :key="idx" class="tag">{{ prefix }}{{ tag }}</span>
  </div>
</template>

<script setup>
import { computed } from 'vue';
const props = defineProps({
  tags: { type: Array, default: () => [] },
  prefix: { type: String, default: '#' }
});

const normalizedTags = computed(() => (Array.isArray(props.tags) ? props.tags : []).filter(Boolean));
</script>

<style scoped>
.tag-display {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}
.tag {
  background: rgba(76, 175, 80, 0.2);
  color: white;
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 500;
  border: 1px solid rgba(76, 175, 80, 0.3);
}
</style>
